import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.css';

const avatarButton =
  process.env.REACT_APP_QATAG === 'true' ? { 'data-qa': 'avatar_button' } : {};

class Dropdown extends Component {
  state = { isOpen: false };

  componentDidMount() {
    this.setState({ isOpen: this.props.isOpen });
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  toggleDropdown = e => {
    e.preventDefault();
    e.stopPropagation();
    const { isOpen } = this.state;
    const { onClose } = this.props;
    this.setState({ isOpen: !isOpen });
    if (isOpen) {
      onClose();
    }
  };

  // when outside of this component clicked
  handleClickOutside = e => {
    if (this.ref && !this.ref.contains(e.target) && this.state.isOpen) {
      this.toggleDropdown(e);
    }
  };

  render() {
    const {
      children,
      className,
      header,
      theme,
      trigger,
      hideOnSelect,
      triggerDisabled,
      unmountContentOnClose,
    } = this.props;

    const parentClasses = classnames(
      'dropdown',
      className,
      theme && theme.map(css => `dropdown--${css}`).join(' '),
      {
        'dropdown--active': this.state.isOpen,
      }
    );

    return (
      <aside className={parentClasses} ref={node => (this.ref = node)}>
        <span
          {...avatarButton}
          className="dropdown__trigger"
          aria-haspopup="true"
          aria-expanded={this.state.isOpen}
          onClick={triggerDisabled ? () => null : this.toggleDropdown} // if trigger is disabled, return empty function
        >
          {trigger}
        </span>
        {(!unmountContentOnClose || this.state.isOpen) && (
          <menu className="dropdown__menu" role="menu">
            <div
              className="dropdown__content"
              onClick={event => hideOnSelect && this.toggleDropdown(event)}
            >
              {header && (
                <header className={'dropdown__header'}>
                  <div className={'dropdown__header-inner'}>{header}</div>
                </header>
              )}
              {children}
            </div>
          </menu>
        )}
      </aside>
    );
  }
}

Dropdown.propTypes = {
  hideOnSelect: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  header: PropTypes.node,
  theme: PropTypes.array,
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  triggerDisabled: PropTypes.bool,
  unmountContentOnClose: PropTypes.bool,
};

Dropdown.defaultProps = {
  isOpen: false,
  onClose: () => null,
  triggerDisabled: false,
  unmountContentOnClose: false,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/common/components/Dropdown/index.js